const DematerialisationProcess = () => {
  return (
    <div className="page">
      <div className="card">
        <h2 className="titlee">
          Simplified Process to Convert Physical Units into Dematerialised
          (Demat) Form
        </h2>

        <ol className="list">
          <li>
            Unit holders intending to hold units in Dematerialised (Demat) form
            are required to have a Beneficiary Account with any Depository
            Participant (DP) of NSDL.
          </li>

          <li>
            The sequence of names mentioned in the folio should match with the
            names in the Beneficiary Account maintained with the DP.
          </li>

          <li>
            Investors should ensure that the combination of names in the account
            statement is identical to that in the Demat account.
          </li>

          <li>
            Other details such as PAN, KYC, etc., mentioned in the folio will be
            verified against the records available with the Depository.
          </li>

          <li>
            Units held in Demat form will be transferable subject to the
            provisions of the respective Scheme(s)/Plan(s) and in accordance
            with the Depositories Act, 1996 and the SEBI (Depositories and
            Participants) Regulations, 1996, as amended from time to time.
          </li>

          <li>
            Once the units are dematerialised, all redemption proceeds and IDCW
            payouts will be credited to the bank account linked with the Demat
            account.
          </li>

          

          <li>
            After dematerialisation, if the Unit Holder wishes to change the
            bank account or update any profile details, they should contact
            their Depository Participant (DP) and follow the prescribed
            procedure.
          </li>

          <li>
            The NSDL portal provides a dedicated facility that enables investors
            to convert paper mutual fund Statements of Account (SOA) into an
            NSDL Demat account.
            <br />
            <strong>
              To know more:{" "}
              <a
                href="https://eservices.nsdl.com/cas-stmt-mf-conv/#/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click Here
              </a>
            </strong>
          </li>
        </ol>
      </div>

      <style>{`
        .page {
  background: #f4f4f4;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  font-family: "Roboto", sans-serif;
}

        .card {
          background: #fff;
          width: 100%;
          max-width: 850px;
          padding: 35px;
          border-radius: 6px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
        }

        .titlee {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          text-decoration: underline;
          line-height: 1.6;
          color: #013C66;
          margin-bottom: 25px;
        }

        .list {
          margin: 0;
          padding-left: 22px;
          font-size: 14px;
          line-height: 1.8;
          color: #333;
        }

        .list li {
          margin-bottom: 14px;
        }

        .list a {
          color: #0056b3;
          text-decoration: underline;
        }

       

        @media (max-width: 768px) {
          .card {
            padding: 20px;
          }

          .title {
            font-size: 14px;
          }

          .list {
            font-size: 12px;
            line-height: 1.7;
          }
        }
      `}</style>
    </div>
  );
};

export default DematerialisationProcess;
